// Consistent spacing container for form fields
import type { ReactNode } from 'react';

export interface FieldWrapperProps {
  children: ReactNode;
  className?: string;
}

export function FieldWrapper({ children, className = '' }: FieldWrapperProps) {
  return <div className={`form-control ${className}`.trim()}>{children}</div>;
}
